import {EntityUnfollowedEvent} from './EntityUnfollowedEvent';

export class ProfileUnfollowed extends EntityUnfollowedEvent {}
